import { render, staticRenderFns } from "./SuperQuickCreate.vue?vue&type=template&id=1f41c102&scoped=true"
import script from "./SuperQuickCreate.vue?vue&type=script&lang=js"
export * from "./SuperQuickCreate.vue?vue&type=script&lang=js"
import style0 from "./SuperQuickCreate.vue?vue&type=style&index=0&id=1f41c102&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f41c102",
  null
  
)

export default component.exports